import type { ThemeDto } from "./types";

/**
 * Palette used for the very first paint and whenever GET /api/theme is
 * unreachable. It matches the defaults baked into globals.css, so an anonymous
 * visitor never sees an unbranded flash while the real theme is fetched.
 */
export const FALLBACK_THEME: ThemeDto = {
  id: "00000000-0000-0000-0000-000000000000",
  name: "STEP-TEMBER",
  primaryColor: "#00359B",
  secondaryColor: "#303F9F",
  backgroundColor: "#F4F7FA",
  surfaceColor: "#FFFFFF",
  textColor: "#001427",
  accentColor: "#CD128A",
  fontFamily: "Roboto, system-ui, sans-serif",
  bannerImageUrl: null,
  logoUrl: null,
  isSiteDefault: true,
};
